<template>
  <div class="purchase-summary">
    <div class="summary__total">
      <div>
        <AmTypography
          class="text--dark-2"
          text="Total"
          typography-style="l5"
          weight="bold"
        />
      </div>
      <div>
        <AmTypography
          class="text--dark-2"
          typography-style="l5"
          weight="bold"
        >
          <template>
            <div>
              {{ cart.total | currency({ codeCurrency: cart.currency_code }) }}
            </div>
          </template>
        </AmTypography>
      </div>
    </div>

    <div
      v-if="wasPaymentInCreditCard"
      class="summary__payment-type"
    >
      <div class="summary__payment-type__payment">
        <AmTypography
          :text="paymentTypeText"
          typography-style="l5"
          weight="bold"
        />
      </div>
      <div
        v-show="isPaymentForCard"
        class="summary__payment-type__installments"
      >
        <AmTypography typography-style="l5">
          <template>
            {{ installmentSeletedLabel }}
          </template>
        </AmTypography>
      </div>
    </div>
  </div>
</template>

<script>
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'PurchaseSummary',
  mixins: [currencyFilterMixin],
  props: {
    paymentType: {
      type: String,
    },
    installmentSeletedLabel: {
      type: String,
    },
  },
  data: () => ({
    defaultCurrency: 'BRL',
  }),
  computed: {
    ...mapState('Checkout', {
      cart: (state) => state.cart,
    }),
    ...mapGetters('Cart', ['getCurrencyCode', 'getIsInternational']),
    currentPaymentTypeSelected() {
      return this.paymentType
    },
    paymentTypeText() {
      const paymentTexts = {
        card: this.$t('steps.payment.purchaseSummary.card'),
        billet: this.$t('steps.payment.purchaseSummary.billet'),
        pix: this.$t('steps.payment.purchaseSummary.pix'),
      }

      return paymentTexts[this.currentPaymentTypeSelected]
    },
    isPaymentForCard() {
      return this.currentPaymentTypeSelected === 'card'
    },
    wasPaymentInCreditCard() {
      return this.cardType === '' || this.cardType === 'credito' || this.cardType === 'multiplo'
    },
  },
  methods: {
    getTextColor() {
      return this.cartFreight() ? '' : 'success'
    },
    cartFreight() {
      return this.cart.freight > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.purchase-summary {
  .summary {
    &__subtotal,
    &__delivery,
    &__discount,
    &__total,
    &__payment-type {
      display: flex;
      justify-content: space-between;
      padding: {
        left: 10px;
        right: 50px;
      }
      margin-bottom: 4px;
    }

    @include mobile {
      &__subtotal,
      &__delivery,
      &__discount,
      &__total,
      &__payment-type {
        padding: {
          left: 0;
          right: 0;
        }
      }

      &__payment-type {
        &__payment {
          width: 65%;
        }

        &__installments {
          width: 35%;
          text-align: right;
        }
      }
    }
  }
}
</style>
